/**
 * Staging environment configuration.
 * Host derived from HRMSApi/appsettings.boltstaging.json ("Jwt:Issuer": "https://stapi.bolterp.com/").
 */
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  apiBaseUrl: 'https://stapi.bolterp.com/api/platform-admin',
  // TODO: set this to BoltUi's real deployed staging origin before "View as" is used here — this
  // repo doesn't define BoltUi's own frontend URL anywhere else, only its backend API URLs.
  boltUiBaseUrl: 'https://st.bolterp.com',
  appName: 'BoltConsole',
};
